import styled from 'styled-components';
export const SupplierContainer = styled.div`
  box-shadow: 4px -4px 8px rgba(4, 15, 15, 0.12);
  overflow: visible;
  border-radius: 5px;
  overflow: hidden;
`;
